import React, { useMemo, useRef, useState, useEffect } from "react";
import { Search, X } from "lucide-react";

// Campo de texto livre com sugestões (residentes + familiares). Preserva texto livre.
const PagadorField = ({ value, onChange, sugestoes = [], placeholder = "Nome (residente, familiar ou livre)", testid }) => {
  const [open, setOpen] = useState(false);
  const [hi, setHi] = useState(0);
  const boxRef = useRef(null);

  useEffect(() => {
    const onDoc = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const filtered = useMemo(() => {
    const t = (value || "").trim().toLowerCase();
    const base = t ? sugestoes.filter((s) => s.label.toLowerCase().includes(t) || (s.sub || "").toLowerCase().includes(t)) : sugestoes;
    return base.slice(0, 40);
  }, [value, sugestoes]);

  const pick = (s) => { onChange(s.label); setOpen(false); };

  const onKey = (e) => {
    if (!open) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setHi((h) => Math.min(h + 1, filtered.length - 1)); }
    else if (e.key === "ArrowUp") { e.preventDefault(); setHi((h) => Math.max(h - 1, 0)); }
    else if (e.key === "Enter" && filtered[hi]) { e.preventDefault(); pick(filtered[hi]); }
    else if (e.key === "Escape") setOpen(false);
  };

  return (
    <div className="relative" ref={boxRef}>
      <div className="flex items-center gap-2 px-3.5 rounded-lg border border-slate-200 focus-within:border-blue-500 focus-within:ring-2 focus-within:ring-blue-100 transition bg-white">
        <Search className="w-4 h-4 text-slate-400 shrink-0" />
        <input
          value={value || ""}
          data-testid={testid}
          onChange={(e) => { onChange(e.target.value); setOpen(true); setHi(0); }}
          onFocus={() => setOpen(true)}
          onKeyDown={onKey}
          placeholder={placeholder}
          className="flex-1 py-2.5 bg-transparent outline-none text-sm text-slate-700"
          autoComplete="off"
        />
        {value && <button type="button" onClick={() => { onChange(""); setOpen(true); }} className="text-slate-300 hover:text-slate-500 shrink-0"><X className="w-4 h-4" /></button>}
      </div>
      {open && filtered.length > 0 && (
        <div className="absolute z-40 mt-1 w-full max-h-56 overflow-y-auto rounded-lg border border-slate-200 bg-white shadow-lg" data-testid={testid ? `${testid}-options` : undefined}>
          {filtered.map((s, idx) => (
            <button
              key={s.key || s.label}
              type="button"
              onMouseEnter={() => setHi(idx)}
              onClick={() => pick(s)}
              className={`w-full text-left px-3.5 py-2 text-sm transition-colors ${idx === hi ? "bg-blue-50 text-blue-700" : "text-slate-700 hover:bg-slate-50"}`}
            >
              <span className="font-medium">{s.label}</span>
              {s.sub && <span className="text-slate-400 ml-2 text-xs">{s.sub}</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default PagadorField;
